import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LanguageService } from 'sham-components/services';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const langService = inject(LanguageService);
  const currentLang = langService.currentLang();

  if (
    req.url.includes('/api/v1/auth/login') ||
    req.url.includes('/api/v1/auth/refresh-token') ||
    req.url.includes('/signin') ||
    req.url.includes('/signup') ||
    req.url.includes('/refresh') ||
    req.url.includes('/assets/i18n/')
  ) {
    return next(req);
  }

  const accessToken = sessionStorage.getItem('accessToken');
  const headers: Record<string, string> = {
    'Accept-Language': currentLang,
  };

  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`;
  }

  const authReq = req.clone({
    setHeaders: headers,
  });

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401) {
        return throwError(() => error);
      }

      return authService.refreshToken().pipe(
        switchMap((response) =>
          next(
            req.clone({
              setHeaders: {
                ...headers,
                Authorization: `Bearer ${response.accessToken}`,
              },
            }),
          ),
        ),
      );
    }),
  );
};
